import { styled } from '@gogame/components';

export const ColorPreview = styled('div')`
  background-color: ${(props) => props.value};
  width: 15px;
  height: 15px;
  margin: 0 auto;
  border-radius: 3px;
`;
